import { render, staticRenderFns } from "./FooterCard.vue?vue&type=template&id=6198236c"
import script from "./FooterCard.vue?vue&type=script&lang=js"
export * from "./FooterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports